angular.module('impactx.panel').component('ixProductPreviewPanel', {
        bindings: {
            name: '=',
            image: '=',
            fallbackImage: '<',
            trns: '=',
            manufacturer: '<',
            siteNumber: '=',
            tagLabel: '<',
            readOnly: "="
        },
        controller: 'ProductPreviewPanelCtrl',
        templateUrl: 'shared/panel/templates/product.preview.panel.tmpl.html'
    }
);